<template>
  <v-app style="overflow-x: hidden" :theme="store.getTheme">
    <v-overlay :persistent="true" no-click-animation class="align-center justify-center" :model-value="store.getMainLoading">
      <v-card width="100vw" height="100vh" style="border-radius: 0 !important;">
        <v-card-text class="d-flex align-center justify-center">
          <div class="overlay-card-center">
            <img :src="getLogo" alt="logo" style="width: 250px">
            <v-progress-circular indeterminate color="primary" />
          </div>
        </v-card-text>
      </v-card>
    </v-overlay>
    <router-view />
  </v-app>
</template>

<script lang="ts" setup>
  import { computed, onBeforeMount } from 'vue'
  import { useAppStore } from '@/stores/app'
  import logo from '@/assets/logo-qrcode.png'
  const store = useAppStore()
  const getLogo = computed(() => {
    return logo
  })
  onBeforeMount(() => {
    store.setTheme(localStorage.getItem('theme') || 'light')
  })
</script>

<style>
section {
  width: 100%;
  padding: 10px;
}
h1 {
  font-size: 28px !important;
}
.overlay-card-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
